import { TPromptGraphData } from "../model/promptGraphTypes";

export function getDataMapFromPromptGraph(promptGraphData?: TPromptGraphData<string>) {
  const dataMap: Record<string, string> = {};
  const execMap: Record<string, string> = {};
  if (promptGraphData) {
    try {
      Object.keys(promptGraphData.nodes).forEach((k) => {
        if (promptGraphData.nodes[k].result) execMap[k] = promptGraphData.nodes[k].result;
        dataMap[k] = promptGraphData.nodes[k].prompt;
      });
      Object.keys(promptGraphData.uniqueFunctionCalls).forEach((f) => {
        dataMap[`functions.${f}`] = promptGraphData.uniqueFunctionCalls[f].result;
      });
      Object.keys(promptGraphData.context).forEach((c) => {
        dataMap[`context.${c}`] = (promptGraphData.context as Record<string, string>)[c];
      });
    } catch {
      // hanlde if needed
    }
  }

  return { dataMap, execMap };
}
